export enum PATHS {
  signUp = '/sign-up',
  login = '/login',
  main = '/',
  courses = '/courses',
  course = '/courses/:groupId/*',
  lesson = '/courses/:groupId/:lessonId/*',
  lessonDescription = 'lessonDescription',
  lessonStudentAttachments = 'lessonAttachments/student',
  lessonTeacherAttachments = 'lessonAttachments/teacher',
  lessonStudentResources = 'lessonResources/student',
  lessonJournal = 'lessonJournal',
  lessonTasks = 'lessonTasks',
  lessonResults = 'lessonResults',
  lessonFinalTest = 'lessonFinalTest',
  lessonWhiteboard = 'lessonWhiteboard',
  // NB: `homework` is taken by the TasksTabs sub-route below — do not reuse it.
  lessonHomework = 'lessonHomework',
  resume = '/resume',
  invoices = '/invoices',
  // The diploma CERTIFICATE page — not `graduationProject` above, which is the
  // lesson-tab дипломный проект.
  diplomas = '/diplomas',
  surveys = '/surveys',
  survey = '/surveys/:assignmentId',
  // Career Center (spec 0018). The first URL segment must stay literally
  // `career`: useActiveMenu matches it against the MenuItems enum VALUE, so
  // renaming the segment silently breaks the menu highlight.
  careerCenter = '/career',
  careerLearning = '/career/learning',
  careerLesson = '/career/learning/:lessonId',
  careerVacancies = '/career/vacancies',
  attachments = '/attachments',
  attachment = '/attachments/:type/:fileId/*',
  homework = 'homework',
  coursework = 'coursework',
  graduationProject = 'graduationProject',
}
